import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export function BaseAcctUnit() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}